<template>
  <div>
    <button class="text-sm btn-xs btn-blue-outline" @click="recordCheckClicked">Record Check</button>
    <b-modal ref="recordCheck" size="lg" :title="`Record Payout Via Check`" no-close-on-backdrop>
      <div class="flex flex-col space-y-2">
        <div>
          <label for="email" class="block text-sm font-medium text-gray-700">Amount</label>
          <div class="mt-1">
            <input v-model.number="amount" type="number" class="new-form-input"/>
          </div>
        </div>
        <div>
          <label for="email" class="block text-sm font-medium text-gray-700">Date Paid</label>
          <div class="mt-1">
            <input v-model="date_paid" type="date" class="new-form-input"/>
          </div>
        </div>
      </div>
       <button class="mt-3 btn btn-green" @click="addPayout">Add Payout</button>
      <div slot="modal-footer" class="w-100">
        <button class="btn-red btn-xs" variant="primary" @click="$refs.recordCheck.hide()">
          Cancel
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    event_id: String
  },
  data () {
    return {
      amount: 0,
      date_paid: new Date().toISOString().split('T')[0]
    }
  },
  methods: {
    recordCheckClicked () {
      this.amount = 0
      this.date_paid = new Date().toISOString().split('T')[0]
      this.$refs.recordCheck.show()
    },
    addPayout () {
      if (!this.amount) {
        return
      }
      let payout = {
        amount: this.amount * 100,
        date: this.date_paid,
        event_id: this.event_id,
        type: 'CHECK',
        status: 'PAID'
      }
      this.$store.state.apiInstance.post(`/data/payouts`, payout)
        .then(response => {
          payout.amount = payout.amount / 100
          this.$emit('checkRecorded', payout)
          this.$refs.recordCheck.hide()
        })
    }
  }
}
</script>

<style>

</style>
